import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GalleryImage} from '../../../models/gallery-image';
import {environment} from '../../../../../environments/environment';
import { LocalizedDatePipe } from '../../../pipes/localized-date.pipe';
import { FileSizePipe } from '@rg/shared-ng';

@Component({
    selector: 'nbd-image-gallery-item',
    templateUrl: './image-gallery-item.component.html',
    styleUrls: ['./image-gallery-item.component.scss'],
    imports: [LocalizedDatePipe, FileSizePipe]
})
export class ImageGalleryItemComponent {
  @Input() image!: GalleryImage;
  @Input() isSelected = false;

  @Output() selected = new EventEmitter<GalleryImage>();

  protected readonly environment = environment;
}
